import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

export default ({ loading }) => {
  return loading ? <div className='d-flex justify-content-center'><CircularProgress color='inherit' /></div> : <></>
}